import { Text } from "@zapier/design-system";
import { addError } from "@zapier/observability";
import { Component, ErrorInfo, ReactNode } from "react";
import styles from "./ErrorBoundary.module.css";

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

class ErrorBoundary extends Component<Props, State> {
  state: State = {
    hasError: false,
  };

  static getDerivedStateFromError(_: Error): State {
    // Update state so the next render shows the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    const renderingError = new Error(error.message);
    renderingError.name = `ReactRenderingError`;
    renderingError.stack = errorInfo.componentStack || undefined;
    renderingError.cause = error;
    // Here you can send the error to a service like Datadog
    addError(renderingError);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className={styles.errorBoundaryWrapper}>
          <Text type="PageHeader">Something went wrong.</Text>
          <br />
          <Text type="Body1">
            There was an error trying to render your Canvas. We have been
            notified about the error and are working to resolve it now.
          </Text>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
